
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSafetyCountourOnProposal as ObiChartSafetyCountourOnProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-safety-countour-on-proposal.js';
 
 
 

 
 export const ObiChartSafetyCountourOnProposal = createComponent({
   react: React,
   tagName: 'obi-chart-safety-countour-on-proposal',
   elementClass: ObiChartSafetyCountourOnProposalElement,
   events: {
     
   }
  });
 
 